import React from 'react';
import { useNavigate } from 'react-router-dom';
import PageContainer from '../../components/layout/PageContainer/PageContainer';
import AdminUserDetail from '../../components/admin/AdminUserDetail';
import { useAuth } from '../../hooks/useAuth';

const AdminUserDetails: React.FC = () => {
  const { user, isAuthenticated, loading } = useAuth();
  const navigate = useNavigate();
  const userFetchedRef = React.useRef(false);

  React.useEffect(() => {
    if (isAuthenticated && !userFetchedRef.current) {
      userFetchedRef.current = true;
    }
  }, [isAuthenticated]);

  React.useEffect(() => {
    if (!loading) {
      if (!isAuthenticated) {
        navigate('/login');
      } else if (!user || user.is_admin !== true) {
        navigate('/dashboard');
      }
    }
  }, [user, isAuthenticated, loading, navigate]);

  if (loading) {
    return (
      <PageContainer>
        <div className="flex justify-center items-center py-12">
          <span className="text-gray-600">Loading...</span>
        </div>
      </PageContainer>
    );
  }

  return (
    <PageContainer title="Admin – User Details">
      <AdminUserDetail />
    </PageContainer>
  );
};

export default AdminUserDetails;
